export default {
	yourTemples: "Vos Temples",
	createNew: "Créer un nouveau temple",
	noTemple: "Aucun temple",
	createDialog: {
		title: "Créer un nouveau Temple",
		name: "Nom du Temple",
		nameHint: "Une majuscule à chaque mot (ou tout en majuscules)",
		acronym: "Sigle",
		acronymHint: "2 à 10 caractères en majuscules, lettres et chiffres uniquement. Sera utilisé comme identifiant.",
		slugTaken: "Ce sigle est déjà utilisé. Veuillez en choisir un autre.",
	},
	roles: {
		title: "Rôle",
		owner: "Propriétaire",
		admin: "Administrateur",
		member: "Membre",
	},
	settings: "Paramètres du Temple",
	publicAgenda: {
		navLabel: "Agenda public",
		enableLabel: "Activer l'agenda public",
		enableHint: "Publie une page avec un lien unique où les gens voient les rituels et peuvent réserver",
		linkLabel: "Lien public",
		linkHint: "Partagez ce lien. Il identifie votre temple en toute sécurité.",
		rotateLink: "Générer un nouveau lien",
		linkCopied: "Lien copié !",
		linkRotated: "Nouveau lien généré. Le précédent ne fonctionne plus.",
		acceptReservations: "Accepter les réservations",
		acceptReservationsHint: "Permet aux personnes de réserver une place pour les rituels publiés",
		requirePhone: "Exiger le téléphone",
		requireEmail: "Exiger l'e-mail",
		requirePhoto: "Exiger une photo",
		requirePhotoHint: "Le consultant prend une photo (webcam) pour terminer la réservation.",
		seeNotifications: "Voir les notifications de réservation",
		agendaWindowDays: "Fenêtre de l'agenda (jours)",
		agendaWindowDaysHint: "Combien de jours à l'avance afficher les rituels",
		welcomeText: "Description courte",
		welcomeTextHint: "Affichée en haut de la page publique, sous le nom (facultatif)",
		longDescription: "Description longue",
		longDescriptionHint: "Affichée dans l’onglet « Plus d’informations » (facultatif)",
		visibleFields: {
			title: "Afficher sur la page publique",
			hint: "Données de la fiche de la maison. Seuls les éléments cochés apparaissent.",
			phone: "Téléphone",
			whatsapp: "WhatsApp",
			email: "E-mail",
			address: "Adresse",
			instagram: "Instagram",
			facebook: "Facebook",
			notRegistered: "non renseigné",
		},
		qrCode: "QR code",
		rotateConfirm: {
			title: "Générer un nouveau lien ?",
			warning: "Le lien actuel cessera de fonctionner immédiatement. Les personnes qui ont déjà l'ancien lien ne pourront plus accéder à l'agenda.",
			instruction: "Pour confirmer, saisissez le code ci-dessous :",
			mismatch: "Le code ne correspond pas.",
			confirm: "Générer un nouveau lien",
		},
		qrDialog: {
			title: "QR code de l'agenda",
			hint: "Téléchargez-le ou imprimez-le pour le diffuser. En pointant la caméra, la personne ouvre l'agenda public.",
			download: "Télécharger",
			print: "Imprimer",
		},
	},
	settingsLabels: {
		defaultCountryCode: "Indicatif du pays par défaut",
		defaultCountryCodeHint: "Prérempli à côté du téléphone dans les fiches.",
		templeData: "Données du Temple",
		general: "Général",
		contact: "Contact",
		address: "Adresse",
		schedule: "Horaires",
		visualIdentity: "Identité visuelle",
		printing: "Impression",
		email: "E-mail",
		notifications: "Notifications",
		name: "Nom du Temple",
		tradition: "Tradition",
		cnpj: "CNPJ",
		razaoSocial: "Raison sociale",
		description: "Description",
		foundedAt: "Date de fondation",
		phone: "Téléphone",
		whatsapp: "WhatsApp",
		templeEmail: "E-mail du Temple",
		instagram: "Instagram",
		facebook: "Facebook",
		saved: "Paramètres enregistrés avec succès !",
	},
	schedule: {
		title: "Jours et horaires de fonctionnement",
		morning: "Matin",
		afternoon: "Après-midi",
		evening: "Soir",
		days: {
			mon: "Lundi",
			tue: "Mardi",
			wed: "Mercredi",
			thu: "Jeudi",
			fri: "Vendredi",
			sat: "Samedi",
			sun: "Dimanche",
		},
	},
	emailSettings: {
		sendReportOnClose: "Envoyer le rapport à la clôture du rituel",
		sendReportOnCloseHint: "Envoie automatiquement le rapport par e-mail aux administrateurs lors de la clôture d'un rituel",
		birthdayEmailEnabled: "Envoyer l'e-mail quotidien des anniversaires",
		birthdayEmailEnabledHint: "Envoie chaque matin un e-mail avec la liste des anniversaires du jour",
		birthdayRecipients: "Destinataires",
		birthdayRecipientsHint: "Sélectionnez qui doit recevoir l'e-mail des anniversaires",
		recipientAdmins: "Administrateurs",
		recipientAllUsers: "Tous les utilisateurs",
		recipientGuides: "Membres guides",
		receiptEmailEnabled: "Envoyer le reçu par e-mail",
		receiptEmailEnabledHint: "Lorsqu'un paiement est enregistré, envoie automatiquement un reçu par e-mail au membre (s'il a une adresse e-mail)",
	},
	attendanceTimeSettings: {
		title: "Présence",
		timeSectionTitle: "Durée de présence pour les fiches",
		timeSectionDescription: "Contrôle les indicateurs visuels de temps sur l'écran d'appel des fiches",
		warningMinutes: "Temps d'avertissement (jaune)",
		warningMinutesHint: "La fiche devient jaune après ce délai (minutes)",
		limitMinutes: "Temps limite (rouge)",
		limitMinutesHint: "La fiche devient rouge après ce délai (minutes)",
	},
	financialSettings: {
		tabGeneral: "Général",
		sectionTitle: "Facturation automatique",
		advanceDays: "Jours d'avance",
		advanceDaysHint: "Générer les charges {n} jours avant la date d'échéance (entre 5 et 25)",
		defaultDueDays: "Échéance par défaut (jours)",
		defaultDueDaysHint: "Une charge ouverte sans échéance est créée avec un délai de {n} jours à partir d'aujourd'hui (entre 0 et 20 ; 0 = échéance aujourd'hui)",
		sendPaymentReminders: "Envoyer des rappels de paiement",
		sendPaymentRemindersHint: "Envoie un e-mail de rappel 3 jours avant la date d'échéance",
		sendOverdueAlerts: "Envoyer des alertes de retard",
		sendOverdueAlertsHint: "Envoie un e-mail d'alerte 1 jour après la date d'échéance",
		allowEditAmountOnSettle: "Autoriser la modification du montant lors du règlement",
		allowEditAmountOnSettleHint: "Lorsqu'il est activé, l'opérateur peut ajuster le montant lors du règlement d'une charge ou d'une cotisation. Désactivé, le règlement solde le montant exact facturé.",
		residualChargePolicy: "Facturation du solde résiduel lors de la modification du montant au règlement",
		residualChargePolicyHint: "Définit ce qui arrive à la différence quand le montant payé est inférieur au montant facturé : pardonner, demander à chaque règlement, ou générer automatiquement une charge pour le solde restant.",
		residualChargePolicyOptions: {
			FORGIVE: "Désactivé — le solde restant est pardonné",
			ASK: "Demander au moment du règlement",
			ALWAYS: "Toujours facturer le solde restant",
		},
	},
	whatsappSettings: {
		sectionTitle: "Alertes WhatsApp",
		sectionDescription: "Messages envoyés depuis le numéro officiel d'ORI, mentionnant le nom du temple.",
		enabled: "Activer les alertes WhatsApp",
		enabledHint: "Envoie les avis financiers également par WhatsApp, en plus de l'e-mail",
		sendPaymentReminders: "Rappels d'échéance",
		sendPaymentRemindersHint: "Envoie un rappel par WhatsApp avant l'échéance des charges",
		sendOverdueAlerts: "Alertes de retard",
		sendOverdueAlertsHint: "Envoie une alerte par WhatsApp lorsqu'une charge est en retard",
		sendPaymentConfirmations: "Confirmations de paiement",
		sendPaymentConfirmationsHint: "Envoie une confirmation par WhatsApp lorsqu'un paiement est approuvé",
		sendAdminAlerts: "Alertes pour les administrateurs",
		sendAdminAlertsHint: "Envoie aux administrateurs des avis de paiement reçu, de dépenses, de doublons et de clôture en attente (chaque admin doit activer WhatsApp dans son propre profil)",
		optInNote: "Chaque personne ne reçoit des messages que si elle dispose d'un numéro de téléphone valide et d'un consentement (opt-in) enregistré dans sa fiche.",
	},
	notifications: {
		channelsTitle: "Canaux d'envoi",
		channelsDescription: "Choisissez par quel canal chaque avis est envoyé. L'e-mail est le canal par défaut ; WhatsApp est un canal supplémentaire.",
		emailChannel: "E-mail",
		emailChannelDesc: "Canal principal, toujours disponible pour ceux qui ont une adresse e-mail enregistrée.",
		channelDefault: "Par défaut",
		whatsappChannel: "WhatsApp",
		whatsappChannelDesc: "Messages envoyés depuis le numéro officiel d'ORI, mentionnant le nom du temple.",
		whatsappOptInNote: "Chaque personne ne reçoit des messages que si elle dispose d'un numéro de téléphone valide et d'un consentement (opt-in) enregistré dans sa fiche.",
		whatsappAddonChip: "Souscrire l'add-on",
		whatsappAddonNote: "Les alertes WhatsApp sont un add-on et ne sont pas incluses dans votre forfait actuel. Souscrivez l'add-on pour activer ce canal.",
		colEvent: "Événement",
		colEmail: "E-mail",
		colWhatsapp: "WhatsApp",
		sectionMember: "Charges (pour le membre)",
		sectionAdmin: "Alertes pour les administrateurs",
		sectionReports: "Rapports et relation",
		eventNewCharge: "Nouvelle charge générée",
		eventNewChargeHint: "Avis envoyé lorsqu'une nouvelle charge ou cotisation est créée.",
		eventReminder: "Rappel de paiement",
		eventReminderDaysPre: "Envoyer",
		eventReminderDaysPost: "jours avant l'échéance (0 à 3 ; 0 = le jour même)",
		eventOverdue: "Charge en retard",
		eventOverdueHint: "Avis envoyé le lendemain de l'échéance.",
		eventConfirmation: "Paiement confirmé / reçu",
		eventConfirmationHint: "Reçu envoyé lorsque le paiement est approuvé.",
		eventAdmin: "Alertes pour la direction",
		eventAdminHint: "Paiement reçu, dépenses à échoir/en retard, doublons et clôture mensuelle en attente.",
		eventClosingReport: "Rapport de clôture mensuelle",
		eventClosingReportHint: "Envoyé avec le PDF à la clôture du mois.",
		eventBirthday: "Anniversaire d'un membre",
		eventBirthdayHint: "Liste des anniversaires du jour, tôt le matin.",
		sectionReservations: "Agenda public",
		eventNewReservation: "Nouvelle réservation",
		eventNewReservationHint: "Avertit les administrateurs quand une réservation publique est confirmée et entre dans la file d'analyse.",
		recipientsLabel: "Destinataires :",
		footNote: "Les avis essentiels (nouvelle charge, échec de prélèvement) sont toujours envoyés lorsque le canal est actif. WhatsApp exige que la personne ait donné son opt-in.",
		alwaysTooltip: "Toujours envoyé lorsque le canal est actif",
		whatsappOffTooltip: "Activez le canal WhatsApp ci-dessus",
		emailOnlyTooltip: "Disponible uniquement par e-mail",
	},
	printing: {
		autoPrint: "Impression automatique à la création de la fiche",
		autoPrintHint: "Lorsqu'activé, l'impression sera déclenchée à chaque création de fiche pendant le rituel",
		autoPrintScheduled: "Imprimer les fiches pour les rituels programmés",
		autoPrintScheduledHint: "Lorsqu'activé, les fiches distribuées pour les rituels futurs seront également imprimées automatiquement",
		paperWidth: "Largeur du papier",
		customMessage: "Message personnalisé",
		customMessageHint: "Texte affiché en bas du reçu (max. 200 caractères)",
		receiptEnabled: "Activer l'impression des reçus",
		receiptEnabledHint: "Affiche le bouton d'impression de reçu sur les mouvements financiers payés",
		showLogo: "Imprimer le logo du temple sur la fiche",
		showLogoHint: "Lorsque désactivé, la fiche sera imprimée sans le logo du temple",
		previewBeforePrint: "Voir le reçu avant d'imprimer",
		previewBeforePrintHint: "Affiche le reçu à l'écran, avec le bouton d'impression à l'intérieur, pour vérifier le nom, le montant et la date avant de gaspiller du papier. Désactivé, il imprime directement.",
		previewReceiptTitle: "Reçu",
		previewHint: "Vérifiez avant de gaspiller du papier.",
		previewPrint: "Imprimer",
		previewPrintFailed: "Impossible d'ouvrir l'impression. Veuillez réessayer.",
		kioskManualHint: "Pour configurer l'impression silencieuse, consultez le",
		kioskManualLink: "manuel d'impression",
		testPrint: "Imprimer une page de test",
	},
	pixSettings: {
		disabledByMp: "Avec l'intégration Mercado Pago active, cette fonction est désactivée — les paiements utilisent le PIX dynamique de Mercado Pago.",
		enabled: "Inclure le QR Code PIX dans les e-mails de facturation",
		enabledHint: "Lorsqu'activé, les e-mails de rappel et de retard incluront un QR Code PIX avec le montant pré-rempli",
		sectionDescription: "Configurez la clé PIX qui sera utilisée pour générer le QR Code.",
		keyType: "Type de clé PIX",
		key: "Clé PIX",
		keyHint: "CPF, CNPJ, e-mail, téléphone ou clé aléatoire",
		keyTypeRequired: "Choisissez le type de clé avant de saisir la clé PIX",
		keyInvalid: {
			CPF: "CPF invalide — vérifiez les 11 chiffres",
			CNPJ: "CNPJ invalide — vérifiez les 14 chiffres",
			EMAIL: "E-mail invalide ou trop long (max 77 caractères)",
			PHONE: "Téléphone invalide — indiquez l'indicatif et le numéro, d'un téléphone brésilien",
			RANDOM: "Clé aléatoire invalide — 36 caractères avec tirets, exactement comme fournie par la banque",
		},
		recipientName: "Nom du bénéficiaire",
		recipientNameHint: "Nom affiché lors de la transaction PIX (max 25 caractères)",
		city: "Ville",
		cityHint: "Ville du bénéficiaire (max 15 caractères)",
	},
	preSenhaSettings: {
		usePreSenha: "Utiliser un numéro de pré-file d'attente pour la présence",
		usePreSenhaHint: "Active le système d'appel par numéro de pré-file d'attente sur la page de distribution des fiches",
	},
	invites: "Invitations",
	pendingInvites: "Invitations en attente",
	noInvites: "Aucune invitation en attente",
	inviteCode: "Code d'invitation",
	inviteCodeDescription: "Partagez ce code pour inviter des membres",
	generateCode: "Générer un code",
	revokeCode: "Révoquer le code",
	codeExpires: "Expire dans",
	copyCode: "Copier le code",
	codeCopied: "Code copié !",
	inviteByEmail: "Inviter par e-mail",
	sendInvite: "Envoyer l'invitation",
	email: "E-mail de l'invité",
	role: "Rôle",
	ritualFunction: "Fonction rituelle",
	ritualFunctionHint: "Ex. : Médium, Cambono, Ogã (facultatif)",
	inviteSent: "Invitation envoyée avec succès !",
	inviteRevoked: "Invitation révoquée",
	expired: "Expiré",
	pending: "En attente",
};
